import { Component } from '@angular/core';

/**
 * Primary actions of an access screen: pinned to the bottom of the card on
 * desktop, a fixed bottom bar below the `lg` breakpoint.
 */
@Component({
  standalone: false,
  selector: 'digicem-access-actions',
  templateUrl: './access-actions.component.html',
  host: { class: 'block lg:mt-auto' },
})
export class AccessActionsComponent {}
